<template>
    <p class="text-xs text-theme-muted">
        Al pagar aceptas la
        <a
            :href="links.license"
            target="_blank"
            rel="noopener"
            class="text-theme-primary underline"
            >Licencia de uso</a
        >, los
        <a
            :href="links.terms"
            target="_blank"
            rel="noopener"
            class="text-theme-primary underline"
            >Términos y condiciones</a
        >
        y la
        <a
            :href="links.privacy"
            target="_blank"
            rel="noopener"
            class="text-theme-primary underline"
            >Política de tratamiento de datos</a
        >
        de Tu Catálogo.
    </p>
</template>

<script>
import { buildLegalDocumentUrl } from "@/common/fields/legal-documents";

export default {
    name: "LegalPaymentNotice",
    data: () => ({
        links: {
            license: buildLegalDocumentUrl("license"),
            terms: buildLegalDocumentUrl("terms"),
            privacy: buildLegalDocumentUrl("privacy")
        }
    })
};
</script>
